import React from 'react'
import { Button } from '@components/Button'
import { Tooltip } from '@components/Tooltip'
import { Icon } from '@UILibrary/Icon'
import './card-action-button.css'

export const CardActionButton = ({ icon, label, className = '', ...props }) => (
  <Tooltip title={label}>
    <Button {...props} className={`text-link card-action-button card-action-button--${icon} ${className}`}>
      <Icon name={icon} size="medium" />
      <span className="card-action-button__label">{label}</span>
    </Button>
  </Tooltip>
)
